import React, { FunctionComponent } from 'react';

import { ProfileListConfig, useProfileList } from '@/scenarios/profiles/hooks/useProfileList';

import styles from './ProfilesFamilyVerticalList.module.css';

interface ProfilesFamilyVerticalListProps extends Omit<ProfileListConfig, 'hintClassName'> {}

export const ProfilesFamilyVerticalList: FunctionComponent<ProfilesFamilyVerticalListProps> = (
    props
) => {
    const profileItems = useProfileList({
        profileViewVariant: 'horizontal',
        ...props,
    });

    return (
        <ul className={styles.root}>
            {profileItems.map((item, index) => (
                /* eslint-disable react/no-array-index-key */
                <li key={index} className={styles.item}>
                    {item}
                </li>
            ))}
        </ul>
    );
};
